import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./favorites.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { Routes } from '~/modules/routes';
import { WireI18n } from '~/modules/stores/i18nStore';
import { selectSavedListingsCount, userStore } from '~/modules/stores/userStore';
class Favorites extends LightningElement {
  constructor(...args) {
    super(...args);
    this.savedListingsAltLabel = void 0;
    this.savedListingsCount = void 0;
  }
  get savedListingsUrl() {
    return `/${Routes.FAVORITE_LISTINGS}`;
  }

  // @ts-expect-error * Automated Type Error Fix
  handleAnalytics(event) {
    let clickUrl = '';
    const menuIdentifier = 'saved list';
    const savedListingsElement = event.target.querySelector('a');
    if (savedListingsElement) {
      clickUrl = savedListingsElement.href;
    }
    event.detail.navLink = {
      menuItem: menuIdentifier,
      clickText: menuIdentifier,
      clickUrl: clickUrl,
      destinationType: 'internal',
      ctaClick: false
    };
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Favorites, {
  wire: {
    savedListingsAltLabel: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.header.favoritesAltText
        };
      }
    },
    savedListingsCount: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectSavedListingsCount
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Favorites, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;